import { useSuspenseInfiniteQuery } from '@tanstack/react-query';

import { giftQueryFactory } from '@/shared/factories/giftQueryFactory';

export const useGiftGoods = (giftNo: number) =>
  useSuspenseInfiniteQuery(giftQueryFactory.goods(giftNo));
